var _path, _circle, _ellipse, _circle2, _circle3, _circle4, _circle5, _circle6, _ellipse2, _circle7, _circle8, _path2, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _ellipse3, _circle17, _ellipse4, _ellipse5, _circle18, _circle19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 153.16 300.905"
    },
    viewBox: "-0.12 -0.17 153.91 301.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m90.022 99.246-2.972.396c2.317 17.465 2.64 67.307 2.66 88.267h3c-.026-21.015-.324-70.736-2.688-88.663zM105.202 187.016c.499-10.469 1.495-24.43 3.486-38.359l-2.969-.425c-2.077 14.538-3.078 29.04-3.563 39.677h3.004l.042-.893zM63.115 94.937l-2.822 1.015c6.94 19.326 11.938 44.899 15.179 65.6a726.403 726.403 0 0 1 3.586 26.039l.037.318h3.02c-2.287-19.398-8.302-63.141-19-92.972zM16.886 50.207l-2.397 1.805c31.79 42.253 47.981 88.14 56.213 123.464a368.038 368.038 0 0 1 2.671 12.433h3.06c-7.187-36.827-23.321-89.526-59.547-137.702z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 55.004,
    r: 7,
    transform: "rotate(-.945 7.018 55.119)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.07,
    cy: 43.987,
    rx: 7,
    ry: 6.999,
    transform: "rotate(-.945 23.014 43.875)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.914,
    cy: 14.657,
    r: 7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.624,
    cy: 7,
    r: 7,
    transform: "rotate(-88.596 58.622 7.001)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.73,
    cy: 68.829,
    r: 5.5,
    transform: "rotate(-.945 17.753 68.916)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.342,
    cy: 60.336,
    r: 5.5,
    transform: "rotate(-.951 32.343 60.335)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.67,
    cy: 80.199,
    r: 4.5,
    transform: "rotate(-.951 25.672 80.207)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.779,
    cy: 34.67,
    rx: 4.499,
    ry: 4.5,
    transform: "rotate(-88.59 66.777 34.67)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.31,
    cy: 73.456,
    r: 4.5,
    transform: "rotate(-.945 40.303 73.442)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.161,
    cy: 39.269,
    r: 4.5,
    transform: "rotate(-88.585 52.16 39.269)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m48.737 8.722-2.685 1.341c31.755 63.692 37.482 142.005 38.311 177.846h2.996c-.832-36.026-6.513-114.705-38.622-179.187zM98.744 177.054c-.016-35.862 3.03-94.635 20.21-133.796l-2.746-1.2c-17.505 40.007-20.449 98.939-20.465 134.996 0 3.907.036 7.54.092 10.854h3.001c-.057-3.316-.093-6.94-.092-10.854zM138.559 108.636l-2.487-1.676c-19.11 28.362-25.784 63.934-27.997 80.948h3.024c2.231-16.932 8.924-51.828 27.46-79.272zM67.989 190.658v110.247h52.592V190.658z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.565,
    cy: 27.878,
    r: 5.5,
    transform: "rotate(-88.59 46.565 27.878)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.464,
    cy: 22.017,
    r: 5.5,
    transform: "rotate(-88.59 62.464 22.017)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.831,
    cy: 40.158,
    r: 7
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.581,
    cy: 46.158,
    r: 7
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.956,
    cy: 54.408,
    r: 5.5
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.768,
    cy: 60.221,
    r: 5.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.456,
    cy: 66.783,
    r: 4.5
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.456,
    cy: 72.033,
    r: 4.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.372,
    cy: 102.419,
    rx: 7,
    ry: 7.001,
    transform: "rotate(-84.503 128.378 102.418)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.16,
    cy: 112.46,
    r: 7,
    transform: "rotate(-84.503 146.153 112.46)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.223,
    cy: 116.304,
    rx: 5.5,
    ry: 5.499,
    transform: "rotate(-84.503 121.223 116.304)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.195,
    cy: 124.843,
    rx: 5.5,
    ry: 5.501,
    transform: "rotate(-84.508 137.196 124.844)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.091,
    cy: 128.512,
    r: 4.5,
    transform: "rotate(-84.497 117.089 128.51)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.537,
    cy: 136.111,
    r: 4.5,
    transform: "rotate(-84.508 131.536 136.113)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowers);
export default __webpack_public_path__ + "static/media/flowers.00347fd6ea4dc04d80c60503dc30de79.svg";
export { ForwardRef as ReactComponent };